// extracted by mini-css-extract-plugin
module.exports = {"categories-list":"categories-list-component-module--categories-list--1c8fi","categoriesList":"categories-list-component-module--categories-list--1c8fi"};